// @ts-nocheck
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { GridOverlay } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../common/components';
import { HouseholdLog } from '../../types';
import { DateUtils } from '../../../../common/utils';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
}));

export type HouseholdLogsProps = {
  data: Array<HouseholdLog>;
};

function HouseholdLogs(props: HouseholdLogsProps) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { data } = props;

  const getColumnDefs = () => [
    {
      field: 'id',
      headerName: t('household.householdId'),
      width: 250,
      flex: 0.4,
    },
    {
      field: 'userId',
      headerName: t('household.householdUserId'),
      width: 250,
      flex: 0.4,
    },
    {
      field: 'createdAt',
      headerName: t('household.householdCreatedAt'),
      width: 200,
      flex: 0.35,
      renderCell: params => DateUtils.format(new Date(params.value), 'ddd, DD MMM YYYY HH:mm:ss Z'),
    },
    {
      field: 'action',
      headerName: t('household.householdAction'),
      width: 250,
      flex: 1,
    },
  ];

  const getRowData = () =>
    (data || []).map(log => ({
      ...log,
      id: log.id,
    }));

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('common.empty')} />
    </GridOverlay>
  );

  return (
    <Box id="HouseholdLogs-container" className={classes.container}>
      {(!data || data.length === 0) ? (
        <EmptyState message={t('household.householdLogsNotAvailable')} />
      ) : (
      <DataTable
        id="HouseholdLogs-table"
        components={{
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={5}
        paginationMode="client"
        pagination
        autoHeight={true}
      />
      )}
    </Box>
  );
}

export default HouseholdLogs;
